import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function FinalCTA() {
  return <section className="py-20 bg-white" data-id="element-96">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-97">
        {/* La decisión es tuya */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-cream-100 rounded-3xl p-8 sm:p-12 text-center border border-cream-200" data-id="element-98">
          <h2 className="text-3xl font-bold text-brown-900 mb-6" data-id="element-99">
            La decisión es tuya
          </h2>

          <p className="text-lg text-brown-800/80 mb-4" data-id="element-100">Puedes seguir:</p>
          <div className="flex justify-center gap-3 mb-6 flex-wrap" data-id="element-101">
            <span className="text-brown-800/60 line-through" data-id="element-102">postergando</span>
            <span className="text-brown-800/60 line-through" data-id="element-103">dudando</span>
            <span className="text-brown-800/60 line-through" data-id="element-104">
              esperando “el momento perfecto”
            </span>
          </div>

          <p className="text-xl font-bold text-brown-900 mb-8" data-id="element-105">
            O puedes empezar hoy mismo a construir algo propio.
          </p>

          <p className="text-lg text-brown-800/80 mb-2" data-id="element-106">Porque quizá…</p>
          <p className="text-lg text-brown-800/80 mb-6" data-id="element-107">
            la oportunidad que estabas buscando…
          </p>
          <p className="font-handwriting text-3xl text-burgundy-600 mb-12" data-id="element-108">
            siempre estuvo en tu cocina.
          </p>

          <h3 className="text-2xl font-bold text-brown-900 mb-8" data-id="element-109">
            Da el primer paso ahora
          </h3>

          <p className="text-lg text-brown-800/80 mb-6" data-id="element-110">Accede hoy a:</p>
          <h4 className="text-2xl font-bold text-burgundy-600 font-serif mb-8" data-id="element-111">
            “Del Horno a Tu Primer Ingreso”
          </h4>

          <Button href="#comprar" className="w-full sm:w-auto py-4 px-10 text-lg mb-8" data-id="element-112">
            SÍ, QUIERO ACCEDER AHORA
          </Button>

          <p className="text-brown-800/80 max-w-md mx-auto" data-id="element-113">
            Y descubre cómo transformar simples budines caseros en una fuente
            real de ingresos desde casa.
          </p>

          <div className="mt-12 pt-8 border-t border-cream-200" data-id="element-114">
            <p className="font-medium text-brown-900 italic" data-id="element-115">
              Tu horno puede seguir siendo solo un horno…
              <br data-id="element-116" />O puede convertirse en el comienzo de una nueva etapa para
              ti.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}